<template>
  <div style="width: 100%;height:100%;text-align: center;color: #fff;background-size: 100% 100%;box-sizing: border-box" @click="clickHandler"
       >
    <div class="icon" :style="{backgroundImage:'url('+(option.attribute.bgUrl ? fileUrl+option.attribute.bgUrl : require('@/assets/custom/tuxiang.png'))+')',width: option.attribute.iconWidth+'px',height: option.attribute.iconHeight+'px', marginTop: option.attribute.iconTop+'px', marginBottom: option.attribute.iconBottom+'px'}"></div>
    <div style="color: #11F3FF;" :style="{width: option.attribute.titleWidth+'px',margin: '0 '+option.attribute.titleLeft+'px'}">{{option.attribute.title}}</div>
    <div :style="{marginTop: option.attribute.totalTop+'px'}">
      <span>{{option.attribute.totalText}}</span>
      <span style="font-family: '840CAI978',serif;color: #32B0FF" :style="{fontSize: option.attribute.numSize+'px'}"> {{totalNum}}</span>
    </div>
    <div style="width: 100%;margin-top: 4px;">
      <div style="display: inline-block;color: #6391CB;margin-right: 8px">{{option.attribute.normalText}}</div>
      <div style="display: inline-block;width: 40%;" v-show="option.attribute.progressShow">
        <progress class="pr" style="width: 100%;height: 4px;background: #666" :value="Math.round(cptData.normal/(cptData.normal+cptData.error)*100)" max="100"
                  :style="'--bar-bg: '+'rgba(128,250,255,0.4)'+';--bar-color:'+'#06D0D5'"/>
      </div>
      <div style="display: inline-block;font-family: '840CAI978',serif;margin-left: 8px;" :style="{fontSize: option.attribute.numSize+'px'}">{{cptData.normal}}</div>
    </div>
    <div style="width: 100%;" v-show="option.attribute.errorShow">
      <div style="display: inline-block;color: #6391CB;margin-right: 8px">{{option.attribute.errorText}}</div>
      <div style="display: inline-block;width: 40%;" v-show="option.attribute.progressShow">
        <progress class="pr" style="width: 100%;height: 4px;background: #CCC" :value="Math.round(cptData.error/(cptData.normal+cptData.error)*100)" max="100"
                  :style="'--bar-bg: '+'rgba(241,50,94,0.4)'+';--bar-color:'+'#F1325E'"/>
      </div>
      <div style="display: inline-block;font-family: '840CAI978',serif;margin-left: 8px;" :style="{fontSize: option.attribute.numSize+'px'}">{{cptData.error}}</div>
    </div>
  </div>
</template>

<script>
import {getDataJson, pollingRefresh,hasNonEmptyValues,hasProperty} from "@/utils/refresh-cpt-data";
import {fileUrl} from '/env'
export default {
  name: "cpt-icon-quota",//ICON指标
  props:{
    width:Number,
    height:Number,
    option:Object,
    components: Array, current: Object
  },
  computed:{
    totalNum(){
      let num = 0;
      if (this.cptData.total){
        num = this.cptData.total
      }else{
        if(this.cptData.normal && this.cptData.error){
          num = this.cptData.normal+this.cptData.error
        }
      }
      return num;
    },
    dataReload() {
      return this.option.attribute.globalDataReload || [0]
    },
  },
  data(){
    return {
      fileUrl,
      uuid:'',
      cptData:[],
      newData:"",
      jsFunFlag:false,
    }
  },
  watch: {
    'option.attribute': {
      handler(obj) {
         this.processData(this.option.cptDataForm,this.newData,this.jsFunFlag);
      },
      deep: true,
    },
    "current.cptShow"(val) {
      console.log('text-show-', val);
      if (val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val) {
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    }
  },
  created() {
    this.uuid = require('uuid').v1();
    // 新增属性兼容旧代码
    if (!this.option.attribute.globalDataReload) {
      this.option.attribute.globalDataReload = [0]
    }
     
    if (this.dataReload.includes(0)) {
      this.refreshCptData();
    }
  },
  methods:{
    refreshCptData(cptDataForm = this.option.cptDataForm,paras){
      pollingRefresh(this.uuid, cptDataForm, ()=> this.loadData(cptDataForm,paras),this.components)
    },
    loadData(cptDataForm,paras){
      const that = this;
      getDataJson(cptDataForm,paras,(res)=> {
          that.newData = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
          that.jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
          that.processData(cptDataForm,that.newData,that.jsFunFlag)
          // this.cptData = res;
        })
    },
    processData(cptDataForm,res,jsFunFlag,isFromGrid){
      // 第一层判断 如果选择数据集
      if(cptDataForm.dataSource == '4') {
            if(this.current.cptOption.interaction.fatherGridId && isFromGrid != 'ninegrid')return

        // 第二层判断 ，如果没有配转换脚本
        if(jsFunFlag) { // 没有全部配置映射字段
        //判断此控件在九宫格里面就不请求数据
            if(hasNonEmptyValues(this.option.attribute.cptTableData)) {
              const dataKey = this.option.attribute.cptTableData;
            // 创建一个新的数组用于存储结果
              let newres = [];
              let newObj = {...res[0]};
            // 如果dataKey中的value有值并且在newObj对象中有对应的值
              dataKey.forEach(item => {
                newObj[item.namekey] = newObj[item.value];
              });
              newres.push(newObj);
              // console.log(newres,'新数组')
              this.cptData = newres[0]; 
            }
          } else { // 如果配置了转换脚本
            this.cptData = res;
          }
      } else { // 不是数据集类型，是静态数据
        this.cptData = res;
      } 
    },
    clickHandler(){
      this.$emit("clickHandler",this.option.interaction,'default',this.option.attribute.title,'cpt-icon-quota')
    }
  }
}
</script>

<style scoped>
.pr::-webkit-progress-bar {
  background-color: var(--bar-bg);
}
.pr::-webkit-progress-value {
  background-color: var(--bar-color);
}
.icon {
  width: 100%;
  height: 50%;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  margin: 0 auto;
}
</style>
